window.fisherAnalytics.legacyCart = {
    version: '1.0.0',
    init: function () {

    },
    processLegacyCart: function(body, response, config) {
        window.fisherAnalytics.utils.log('Process EU cartlet');
        if (response.responseText.indexOf(config.responseText) !== -1 && env.programmaticCartletClick) {

            //Reset the flag
            env.programmaticCartletClick = false;

            var data = JSON.parse(response.responseText);
            if (data && response.status === 200) {
                window.fisherAnalytics.utils.log('Process CA data 200');
                try{
                    // Extract line items
                    var cartId = window.fisherAnalytics.legacyCart.getLegacyCartId();
                    var cartTotal = data.cartTotal || 0.00;
                    var costBreakdown = {};
                    var lineItems = window.fisherAnalytics.legacyCart.populateLegacyLineItems(data);
                    var cartSubTotal =  lineItems.cartSubTotal || 0.00;
                    let lastAddedItem;

                    if (window.digitalData) {
                        // Set cart and its items
                        window.digitalDataManager.setCart(cartId, cartSubTotal, cartTotal, costBreakdown);
                        var lastItem;
                        var existingProduct;
                        if (lineItems.length > 0) {
                            //EU does not order items consistently, so we need to find the last added item differently
                            if(sessionStorage.getItem('lastAddedItem')){
                                lastAddedItem = sessionStorage.getItem('lastAddedItem');
                                sessionStorage.removeItem('lastAddedItem');
                                lastItem = lineItems.find(function(item){
                                    return item.lineItemID === lastAddedItem;
                                });
                            } else {
                                lastItem = lineItems[0];
                            }
                        }

                        window.digitalDataManager.removeCartItems(); //clear products before repopulating
                        lineItems.forEach(function(item) {
                            window.digitalDataManager.setCartItem(item.lineItemID, item.partNumber, item.variation, item.productTitleNoGlyphs, item.price, item.quantity, item.findingMethod);
                        });

                        // Store cart details in local storage
                        window.fisherAnalytics.cart.saveCartDetailsToLocalStorage(cartId, cartSubTotal, cartTotal, costBreakdown, lineItems);
                        // Create and dispatch cartAdd event with the last item in lineItems
                        if (lastItem) {
                            const payload = {
                                cartId: cartId || "",
                                subTotal: cartSubTotal || 0.00,
                                products: [{
                                    name: lastItem.productTitleNoGlyphs,
                                    sku: lastItem.partNumber,
                                    price: lastItem.price,
                                    quantity: lastItem.quantity,
                                    variation: lastItem.variation,
                                    discount: ""
                                }]
                            };

                            const cartAddEvent = new CustomEvent('cartAdd', {
                                detail: {
                                    cartPayload: payload
                                }
                            });
                            document.dispatchEvent(cartAddEvent);
                        }
                    }
                } catch (e) {
                    window.fisherAnalytics.utils.log("issue with new data layer from global ui intercept (EU): " + e);
                }
            }
        }
    },
    processLegacyFindingMethod: function(body, response, config) {
        window.fisherAnalytics.utils.log('Process legacy finding method');
        if (response.responseText.indexOf(config.responseText) !== -1) {
            let sectionsWithNoCartletTrigger = ['/store1/mylist'];
            var data = JSON.parse(response.responseText);
            if (data && response.status === 200) {
                window.fisherAnalytics.utils.log('Process legacy data 200');
                try{
                    //Sending finding method to local storage so that it can get picked up later when the real cartlet & process call is made
                    var cartId = window.fisherAnalytics.legacyCart.getLegacyCartId();
                    window.digitalDataManager.setCart(cartId, "", 0, {});
                    var addToCartFrom = "";
                    var catalogNumber = "";
                    if (typeof body === 'string') {
                        const params = window.fisherAnalytics.legacyCart.parseLegacyAddToCartForm(body);
                        addToCartFrom = params.addToCartFrom || "";
                        catalogNumber = params.catalogNumber || "";
                        sessionStorage.setItem('lastAddedItem', catalogNumber);
                        window.digitalDataManager.setCartItem(catalogNumber, catalogNumber, "", "", 0.0, 0, addToCartFrom);
                        //Trigger the cartlet if URL is in sectionsWithNoCartletTrigger
                        const currentPath = window.location.pathname;
                        for(let i=0; i<sectionsWithNoCartletTrigger.length; i++){
                            if(currentPath.indexOf(sectionsWithNoCartletTrigger[i]) !== -1){
                                document.querySelector('#cart-link-a').click();
                                break;
                            }
                        }
                    }
                    delete window.digitalData.cart.products[catalogNumber] //clear product now that it is saved to local storage
                } catch (e) {
                    window.fisherAnalytics.utils.log("issue with new data layer from global ui intercept (Legacy finding method): " + e);
                }
            }
        }
    },
    populateLegacyLineItems: function(data) {
        function toTwoDecimals(n) {
            if (typeof n === 'string') {
                // Remove currency symbols, codes, and commas
                n = n.replace(/[^\d.-]/g, '');
            }
            const num = parseFloat(n) || 0;
            return Math.round(num * 100) / 100;
        }

        var lineItems = [];
        var cartSubTotal = 0.00;

        // Check all item groups and process their items
        var allGroups = ['basketitems', 'extraitems'];

        allGroups.forEach(function(groupName) {
            if (data && data[groupName] && Array.isArray(data[groupName])) {
                data[groupName].forEach(function(item) {
                    var partNumber = item.productcode ? item.productcode.replace(/-/g, "") : "";
                    var productTitleNoGlyphs = item.productlabel || "";
                    var lineSubtotalRaw = toTwoDecimals(item.totalprice) || 0.00; //need to remove currency formatting if any
                    var quantity = item.nb || 0;
                    var unitPrice = quantity > 0 ? (lineSubtotalRaw / quantity) : 0;
                    var price = toTwoDecimals(item.itemprice); // unit price (2 decimals)
                    var variation = item.unit || "";
                    var findingMethod = ""; //leave finding method empty for legacy EU
                    // create running subtotal
                    cartSubTotal += lineSubtotalRaw;

                    lineItems.push({
                        lineItemID: partNumber,
                        partNumber: partNumber,
                        productTitleNoGlyphs: productTitleNoGlyphs,
                        price: price,
                        quantity: quantity,
                        variation: variation,
                        findingMethod: findingMethod
                    });
                });
            }
        });

        cartSubTotal = toTwoDecimals(cartSubTotal);
        lineItems.cartSubTotal = cartSubTotal;
        return lineItems;
    },
    getLegacyCartId: function() {
        // For EU, the cart ID is not provided by the backend for legacy carts
        if(localStorage.getItem("CART_ID")) return localStorage.getItem("CART_ID");
        //No cartId in local storage, generate a new one
        if(window.utils){
            if(window.utils.getCookie('gsessionId')){
                window.fisherAnalytics.legacyCart.setLegacyCartId(window.utils.getCookie('gsessionId') + '-' + Date.now().toString().slice(-5));
                return localStorage.getItem("CART_ID");
            } else {
                return Date.now();
            }
        } else {
            return Date.now();
        }
    },
    parseLegacyAddToCartForm: function(body) {
        const params = {
            addToCartFrom: '',
            catalogNumber: '',
            unit: ''
        };
        try {
            if (typeof body === 'string') {
                body.split('&').forEach(pair => {
                    if (!pair) return;
                    const [rawKey, rawVal] = pair.split('=');
                    const key = decodeURIComponent(rawKey || '').trim();
                    const value = decodeURIComponent((rawVal || '').replace(/\+/g, ' ')).trim();
                    if (key === 'addToCartFrom') {
                        params.addToCartFrom = value;
                    } else if (key === 'shoppingCartCatNum') {
                        params.catalogNumber = value;
                    } else if (key === 'shoppingCartUnits') {
                        params.unit = value;
                    }
                });
                return params;
            }
        } catch (e) {
            window.fisherAnalytics.utils.log("issue with parsing legacy form/body data: " + e);
        }
        return params;
    },
    setLegacyCartId: function(cartId) {
        localStorage.setItem("CART_ID", cartId);
    }
}